import { render, staticRenderFns } from "./DistributionOfMarketingBudget.vue?vue&type=template&id=2498e527"
import script from "./DistributionOfMarketingBudget.vue?vue&type=script&lang=js"
export * from "./DistributionOfMarketingBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports